/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2372
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
var r = require(/* 724 */"./724")
var i = function (e) {
  this.id = r.id()
  this.registry = e
}
exports.ContainerModule = i
var o = function (e) {
  this.id = r.id()
  this.registry = e
}
exports.AsyncContainerModule = o
